import __request__ from "routing/request";
export function overview() {
  return __request__("GET", "/api-docs", null, {}, {
    "Accept": ["application/json"]
  });
}
export function globalOverview() {
  return __request__("GET", "/api-docs/global", null, {}, {
    "Accept": ["application/json"]
  });
}
export function route(route2) {
  return __request__("GET", `/api-docs/${route2}`, null, {}, {
    "Accept": ["application/json"]
  });
}
